/* eslint-disable no-dupe-keys */
export default {
  ev_charging_station_settlement: {
    name: '充电站结算',
    // 属性（一般与对象内容匹配）
    prop: {
      trade_number: '结算编号',
      settled_begin_time: '结算开始时间',
      settled_end_time: '结算结束时间',
      settled_days: '结算天数',
      service_provider: '运营商',
      ev_charging_station: '充电站',
      operator: '操作人',
      orders_amount: '订单总额',
      orders_consumed_power: '结算电量',
      orders_charge_amount: '订单电费',
      orders_service_amount: '订单服务费',
      orders_service_amount_after_discount: '优惠后订单服务费',
      orders_count: '订单数',
      net_income_amount: '运营商净收入',
      transaction_fee_amount: 'ECMP交易手续费',
      sharing_amount: 'ECMP渠道费',
      sharing_discount_amount: 'ECMP渠道优惠',
      sharing_bef_discount_amount: '平台优惠前分成',
      evcs_sharing_amount: '互联互通渠道费',
      evcs_transaction_fee_amount: '代理交易手续费',
      status: '状态',
      history_settlement_rule: '结算规则',
      created_at: '执行时间',
      updated_at: '更新时间',
      settled_time_range: '结算时间范围',
      description: '描述',
      settlement_type: '结算类型',
      idle_fee_bills_total_amount: '占位费账单总额',
      idle_fee_bills_amount: '占位费分成',
      idle_fee_bills_count: '占位费账单数',
      idle_fee_bills_transaction_fee_amount: '占位费交易手续费',
      idle_fee_bills_tax_amount: '占位费税费',
      settled_total_amount: '结算总额',
      total_orders_amount: '订单实收金额',
      total_sharing_amount: '渠道费',
      total_transaction_fee_amount: '交易手续费',
      total_tax_amount: '税费',
      user: '适用用户',
      charging_card_amount: '充电卡支付金额',
      orders_payable_amount: '订单原价',
      settled_amount: '结算原价',
      settled_discount_amount: '优惠/商家让利金额',
      merchant_discount_amount: '商家让利金额',
      merchant_discount_rate: '商家让利比例',
      charge_channel: '充电渠道',
      discounts_amount: '优惠金额',
      third_party_sharing_fee_amount: '第三方渠道费',
      settled_charge_amount: '结算电费',
      settled_service_amount: '结算服务费',
      settled_date_type: '结算时间类型',
      untransferred_amount: '未转账金额',
      charge_channel: '结算渠道'
    },
    // 列表页字段（列控制使用，需要与列表页匹配）
    columns: {
      settled_begin_time: '结算开始时间',
      settled_days: '结算天数',
      ev_charging_station_id: '充电站',
      charge_channel: '充电渠道',
      orders_count: '订单数',
      orders_amount: '订单总额',
      orders_consumed_power: '结算电量',
      orders_service_amount: '订单服务费',
      net_income_amount: '运营商净收入',
      transaction_fee_amount: 'ECMP手续费',
      sharing_amount: 'ECMP渠道费',
      evcs_sharing_amount: '互联互通渠道费',
      third_party_sharing_fee_amount: '第三方渠道费',
      merchant_discount_amount: '商家让利金额',
      discount_transaction_fee_amount: '手续费',
      evcs_transaction_fee_amount: '代理平台手续费',
      duplicated_settlement: '结算状态',
      idle_fee_bills_amount: '占位费账单金额',
      idle_fee_bills_count: '占位费账单数',
      idle_fee_bills_tax_amount: '占位费税费',
      idle_fee_bills_transaction_fee_amount: '占位费交易手续费',
      orders_payable_amount: '订单原价',
      discounts_amount: '优惠金额',
      settled_discount_amount: '优惠/商家让利金额',
      orders_service_amount_after_discount: '订单优惠后服务费金额',
      discountable_count: '优惠项目数量',
      settled_charge_amount: '结算电费',
      settled_service_amount: '结算服务费',
      settled_count: '结算数量'
    },
    // Enum的属性
    statuses: {
      successful: '成功',
      unsuccessful: '失败'
    },
    duplicated_settlements: {
      true: '已结算',
      false: '未结算'
    },
    transferred_settlements: {
      true: '已转账',
      false: '未转账'
    },
    settlement_types: {
      station_order: '充电订单',
      station_idle_fee_bill: '占位订单',
      station_order_discount: '订单优惠',
      station_charging_package: '充电包优惠'
    },
    settled_date_types: {
      settled_by_charging_finished_date: '按充电结束时间',
      settled_by_payment_date: '按支付时间'
    },
    evcs_sharing_types: {
      sharing_by_total_amount: '按总价优惠',
      sharing_by_service_amount: '按服务费优惠'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询结算编号',
      select_charge_channel: '选择充电渠道',
      select_orders_source_type: '选择订单来源',
      select_idle_fee_bills_source_type: '选择占位费账单来源'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      order_settlements: '订单结算',
      idle_fee_bill_settlements: '占位费结算',
      discount_settlements: '优惠结算',
      charging_package_settlements: '充电包结算'
    },
    titles: {
      export_orders_settlement: '导出站订单结算统计',
      export_idle_fee_bills_settlement: '导出站占位费结算统计',
      export_service_provider_settlement_report: '导出运营商对账报表',
      implement_order_settlement: '执行订单结算',
      implement_idle_fee_bill_settlement: '执行占位费结算',
      implement_discount_settlement: '执行优惠结算',
      implement_charging_package_settlement: '执行充电包结算',
      pre_implement_settlement: '执行充电站预结算',
      base_info: '基本信息',
      settlement_rule: '结算规则',
      idle_fee_settlement_rule: '占位结算规则',
      discount_settlement_rule: '优惠结算规则',
      charging_package_settlement_rule: '充电包结算规则'
    },
    labels: {
      transaction_fee: '手续费',
      ecmp_platform: 'ECMP平台',
      settlement_rule: '结算规则'
    },
    calculate_info: {
      calculate_result: '计算结果'
    },
    btn: {
      resettle: '重新结算',
      execute_settled: '执行结算',
      calc_preview: '结算预览',
      view_ref_orders: '参考订单',
      pre_calc_preview: '预结算预览',
      view_ref_idle_fee_bills: '参考占位费账单',
      view_orders: '查看订单',
      cancel_orders_filter: '取消查看'
    },
    validates: {
      not_in_settlement_rule_timerange: '选择的时间不在结算规则有效时间范围内'
    },
    tips: {
      net_income_amount: '净收入是指扣除交易手续费、税费 和 平台渠道费用后，运营商获得的最终获得的纯收入',
      orders_payable_amount: '含充电订单/占位订单的优惠前金额',
      settled_discount_amount: 'E享行优惠/第三方渠道优惠',
      total_transaction_fee_amount: '交易手续费 = (订单原价 - 渠道费) x 手续费设定比例',
      total_sharing_amount: '使用不同的APP充电，对应渠道会收取相应的费用',
      total_tax_amount: '订单开票、交易，会产生相应的税费',
      charging_card_amount_desc: '如果充电卡费用尚未向运营商收取，请手动创建运营商流水扣除当前费用；如果已经收取则忽略当前提示',
      charging_card_amount: '当前结算的订单中包含了 {0}元 使用充电卡支付',
      evcs_sharing_basing_on_total_amount_formula: '按总价的代理价优惠 = 订单总额 x 代理价优惠折扣',
      evcs_sharing_basing_on_service_amount_formula: '按服务费的代理价优惠 = 订单服务费总额 x 代理价优惠折扣',
      ecmp_sharing_basing_on_total_amount_formula: '按总价的分成 = (订单总额 - 代理价优惠) x ECMP分成比例',
      ecmp_sharing_basing_on_service_amount_formula: '按服务费的分成 = (订单服务费总额 - 代理价优惠) x ECMP分成比例',
      evcs_transaction_fee_amount_formula: '代理商代收款交易手续费 = (订单总额 - 代理价优惠) x 代理交易手续费',
      net_income_formula: '净收入 = 订单实收总额 - 交易手续费 - ECMP分成 - 占位费税费 - 占位费交易手续费',
      idle_fee_sharing_amount_formula: '占位费税费 = 占位费账单总额 x 占位费税费比例',
      idle_fee_transaction_fee_amount_formula: '占位费交易手续费 = 占位费账单总额 x 占位费交易手续费',
      ecmp_transaction_fee_amount_formula: 'ECMP交易手续费 = (订单总额 - 代理价优惠) x ECMP手续费',
      settle_confirm: '结算后，净收入将转入运营商余额？',
      discount_settlement_net_income_formula: '净收入 = 优惠金额 - 商家让利 - ECMP渠道费 - 第三方渠道费 - 手续费',
      merchant_discount_amount: '商家让利部分，不需要结算钱给商家',
      merchant_discount_amount_formula: '商家让利金额 = 优惠总额 x 商家让利费率',
      discount_sharing_amount_formula: 'ECMP渠道费 = (优惠总额 - 商家让利金额) x ECMP渠道费率',
      third_party_sharing_fee_amount_formula: '第三方渠道费 = (优惠总额 - 商家让利金额) x 第三方渠道费率',
      transaction_fee_amount_formula: '交易手续费 = (优惠总额 - 商家让利金额 - ECMP渠道费 - 第三方渠道费) x 手续费率',
      charging_package_settlement_net_income_formula: '净收入 = 结算金额 - ECMP渠道费 - 手续费',
      charging_package_settlement_sharing_amount_formula: 'ECMP渠道费 = 结算金额 x ECMP渠道费率',
      charging_package_settlement_transaction_fee_amount_formula: '交易手续费 = (结算金额 - ECMP渠道费) x 手续费率',
      settled_charge_amount_formula: '结算电费 = 结算电量 x 结算电价',
      settled_service_amount_formula: '结算服务费 = 结算电量 x 结算服务价'
    },
    ev_charging_station_order_pre_settlement: '充电站订单预结算',
    order_pre_settlements: {
      total_orders_count: '订单预结算',
      rebuild_orders_count: '订单重新预结算数量'
    },
    export_dialog: {
      statistics_date: '统计月份',
      settlement_date: '结算月份',
      ev_charging_station: '充电站',
      orders_source_scope: '订单来源',
      idle_fee_bills_source_scope: '占位费账单来源',
      service_provider_id: '运营商',
      user: '用户',
      preview: '预览',
      confirm_export: '确认导出'
    },
    list_tabs: {
      all: '全部',
      ecmp_charging_settlements: 'ECMP充电订单',
      evcs_charging_settlements: '互联互通充电订单',
      idle_fee_settlements: '占位订单',
      fail_settlements: '结算失败',
      station_daily_settlements: '充电站日结算',
      service_provider_daily_settlements: '运营商日结算'
    },
    // 订单详情渠道活动展示
    order_detail_settlement_discount: {
      name: '渠道活动名',
      conent: '渠道活动内容'
    }
  }
}
